import React, { useEffect, useMemo } from "react";
import Header from "./Header";
import "react-phone-input-2/lib/style.css";
import Side_bar from "./Side_bar";
import useState from "react-usestateref";
import { Link, useNavigate } from "react-router-dom";
import { getMethod, postMethod } from "../core/service/common.api";
import apiService from "../core/service/detail";
import { toast } from "react-toastify";
import { Bars } from "react-loader-spinner";
import countryList from "react-select-country-list";
import WARNICON from "../assets/icons/withdraw-warn.webp";
import { useRef } from "react";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
};

const Dashboard = () => {
    const [getKYCData, setgetKYCData] = useState(0);
    const [CurrentStep, setCurrentStep] = useState("aadhar");
    const [getKYCDataReject, setgetKYCDataReject] = useState("");
    const [siteLoader, setSiteLoader] = useState(false);
    const options = useMemo(() => countryList().getData(), []);
    const navigate = useNavigate();
    const [siteData, setSiteData] = useState("");
    const [siteStatus, setSiteStatus] = useState("");
    const [kycStatus, setkycStatus] = useState("Active");
    const today = new Date().toISOString().split("T")[0];
    const [panNumber, setPanNumber] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [ifscCode, setIfscCode] = useState("");

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handlePanChange = (e) => {
        let value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");

        // Max 10 characters
        if (value.length > 10) {
            value = value.slice(0, 10);
        }

        setPanNumber(value);
    };

    useEffect(() => {
        getSitedata();
        Kycdata();
    }, []);

    const getSitedata = async () => {
        try {
            var data = {
                apiUrl: apiService.getSitedata,
            };
            setSiteLoader(true);
            var resp = await getMethod(data);
            setSiteLoader(false);
            if (resp.status == true) {
                setSiteData(resp.data);
                setSiteStatus(resp.data.siteStatus);
                setkycStatus(resp.data.kycStatus);
            }
        } catch (error) { }
    };

    const verifyPAN = async () => {
        if (panNumber.length !== 10) {
            showerrorToast("Invalid PAN number");
            return;
        }
        handleClose();
        setSiteLoader(true);
        try {
            const resp = await postMethod({
                apiUrl: apiService.verifyPAN,
                payload: { pan: panNumber },
            });

            if (resp.status == true) {
                showsuccessToast("PAN Verified");
                getSitedata();
            } else {
                showerrorToast(resp.message || "PAN Verification Failed");
            }
        } catch (err) {
            console.error("PAN verification error:", err);
            showerrorToast("Something went wrong during PAN verification.");
        } finally {
            setSiteLoader(false);
            Kycdata(); // continue regardless of PAN status
        }
    };

    const Kycdata = async () => {
        setSiteLoader(true);
        try {
            const resp = await getMethod({ apiUrl: apiService.getNewkyc });

            if (resp.status) {
                setgetKYCData(resp.data);
                setCurrentStep(resp.currentstep);
                if (resp.currentstep === "aadhar" || resp.currentstep === "pan") {
                    verifyKyc();
                }
            } else {
                // showerrorToast("Failed to fetch KYC data");
            }
        } catch (err) {
            console.error("Error in KYC data:", err);
            // showerrorToast("Something went wrong while fetching KYC data.");
        } finally {
            setSiteLoader(false);
        }
    };

    const verifyKyc = async () => {
        setSiteLoader(true);
        try {
            const resp = await getMethod({ apiUrl: apiService.CheckAadhar });

            if (resp.status == true && CurrentStep === "aadhar") {



                setCurrentStep("pan");


                console.log("CurrentStep", CurrentStep);
                handleOpen();
                showsuccessToast("Aadhaar verified");

            } else {
                // showerrorToast("Aadhaar verification failed");
            }
        } catch (err) {
            console.error("Error in Aadhaar check:", err);
            // showerrorToast("Something went wrong while verifying Aadhaar.");
        } finally {
            setSiteLoader(false);
        }
    };

    const GetAadharLink = async () => {
        handleClose();
        setSiteLoader(true);
        try {
            const resp = await postMethod({ apiUrl: apiService.getAadhar });

            if (resp.status) {
                const Aadhar = resp.result;

                if (Aadhar.status === 1 && Aadhar.data?.url) {
                    window.open(Aadhar.data.url, "_blank");
                    navigate("/dashboard");
                } else {
                }
            } else {
            }
        } catch (err) {
            console.error("Aadhaar link error:", err);
        } finally {
            setSiteLoader(false);
        }
    };

    const showsuccessToast = (message) => {
        toast.dismiss();
        toast.success(message);
    };

    const showerrorToast = (message) => {
        toast.dismiss();
        toast.error(message);
    };

    const verifyBankAccount = async () => {
        if (!accountNumber || accountNumber.length < 9 || accountNumber.length > 20) {
            showerrorToast("Please enter a valid account number (9-20 digits)");
            return;
        }

        if (!ifscCode || ifscCode.length !== 11) {
            showerrorToast("Please enter a valid 11-character IFSC code");
            return;
        }

        handleClose();
        setSiteLoader(true);

        try {
            const resp = await postMethod({
                apiUrl: apiService.verifyBankAccount,
                payload: {
                    accountNumber,
                    ifsc: ifscCode
                },
            });

            if (resp.status) {
                showsuccessToast("Bank account verified successfully");
                getSitedata();
                Kycdata();
            } else {
                showerrorToast(resp.message || "Bank account verification failed");
            }
        } catch (err) {
            console.error("Bank verification error:", err);
            showerrorToast("Something went wrong during bank verification.");
        } finally {
            setSiteLoader(false);
        }
    };

    return (
        <>
            <section>
                <Header />
            </section>

            {siteLoader == true ? (
                <div className="loadercss">
                    <Bars
                        height="80"
                        width="80"
                        color="#ffc630"
                        ariaLabel="bars-loading"
                        wrapperStyle={{}}
                        wrapperclassName=""
                        visible={true}
                    />
                </div>
            ) : (
                <main className="dashboard_main">
                    <div className="container-lg">
                        <div className="row">
                            <div className="col-lg-2 col-md-0">
                                <Side_bar />
                            </div>

                            <div className="col-lg-10 col-md-12">
                                <section className="asset_section">
                                    {kycStatus == "Active" ? (
                                        <>
                                            <div className="row">
                                                <div className="identification_title">
                                                    Identification
                                                </div>
                                                <div className="col-lg-7">
                                                    {getKYCData == 3 ? (
                                                        <div className="reject-box">
                                                            <span>
                                                                <i className="fa-solid fa-triangle-exclamation"></i>
                                                            </span>
                                                            <span>Rejected reason</span>

                                                            <p className="reject-reason mt-2">
                                                                {" "}
                                                                {getKYCDataReject.rejectReson}{" "}
                                                            </p>
                                                        </div>
                                                    ) : getKYCData == 2 ? (
                                                        <div className="pending-box">
                                                            <span>
                                                                <i className="fa-solid fa-triangle-exclamation"></i>
                                                            </span>
                                                            <span>
                                                                Your KYC verification is currently pending.
                                                                Please wait for the admin to review your
                                                                details. Thank you for your patience.
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        ""
                                                    )}

                                                    {getKYCData == 1 ? (
                                                        <>
                                                            <div className="standard_verify_box">
                                                                <div className="standard_verify_content id-content">
                                                                    <h3>
                                                                        Your account has been successfully verified.
                                                                    </h3>
                                                                    <p className="kyc-cont">
                                                                        Your account has been verified, granting you
                                                                        access to all platform features and the
                                                                        ability to perform transactions. Enjoy
                                                                        additional benefits as well!
                                                                    </p>
                                                                </div>
                                                                <div className="standard_verify_img verify-img-cont">
                                                                    <img
                                                                        src={require("../assets/success.webp")}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="individual_kyc_box">
                                                                <div className="identification_features">
                                                                    <div className="individual_title mb-3">
                                                                        {/* {getKYCData == 1 ? "You're now able to access all features starting today." : "Unlock Exculsive Perks After Verification"} */}
                                                                    </div>

                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">Trading</h3>
                                                                        <p className="text-green">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">
                                                                            Withdrawals
                                                                        </h3>
                                                                        <p className="text-green">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">
                                                                            Crypto Deposit
                                                                        </h3>
                                                                        <p className="text-green">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">
                                                                            Fiat Deposit
                                                                        </h3>
                                                                        <p className="text-green">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">
                                                                            P2P trading
                                                                        </h3>
                                                                        <p className="text-green">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>

                                                                    <div className="my-4">
                                                                        {getKYCData == 2 ? (
                                                                            <button
                                                                                disabled
                                                                                className="action_btn opt-nowrap w-100 disabl"
                                                                                type="button"
                                                                            >
                                                                                Pending
                                                                            </button>
                                                                        ) : getKYCData == 1 ? (
                                                                            <Link to="/deposit">
                                                                                <button
                                                                                    className="action_btn opt-nowrap w-100 kyc_depo_nw"
                                                                                    type="button"
                                                                                >
                                                                                    Deposit
                                                                                </button>
                                                                            </Link>
                                                                        ) : (
                                                                            <button
                                                                                className="action_btn opt-nowrap w-100"
                                                                                type="button"
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#exampleModal"
                                                                            >
                                                                                Verify Now
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="standard_verify_box">
                                                                <div className="standard_verify_content id-content">
                                                                    <h3>
                                                                        Complete Your Identity Verification to
                                                                        Unlock Full Access
                                                                    </h3>
                                                                    <p className="kyc-cont">
                                                                        To ensure your account is secure and
                                                                        compliant with local laws, please complete a
                                                                        quick identity verification. This will allow
                                                                        you to access all our services seamlessly.
                                                                    </p>
                                                                </div>
                                                                <div className="standard_verify_img verify-img-cont">
                                                                    <img
                                                                        src={require("../assets/refer_earn_banner.webp")}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="individual_kyc_box">
                                                                <div className="identification_features">
                                                                    <div className="individual_title mb-3">
                                                                        {/* {getKYCData == 1 ? "You're now able to access all features starting today." : "Unlock Exculsive Perks After Verification"} */}
                                                                    </div>

                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">Trading</h3>
                                                                        <p className="text-yellow">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">
                                                                            Withdrawals
                                                                        </h3>
                                                                        <p className="text-yellow">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">
                                                                            Crypto Deposit
                                                                        </h3>
                                                                        <p className="text-yellow">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">
                                                                            Fiat Deposit
                                                                        </h3>
                                                                        <p className="text-yellow">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>
                                                                    <div className="features-box">
                                                                        <h3 className="feature-title">
                                                                            P2P trading
                                                                        </h3>
                                                                        <p className="text-yellow">
                                                                            <i className="ri-check-line"></i>
                                                                        </p>
                                                                    </div>

                                                                    <div className="my-4">
                                                                        {getKYCData == 2 ? (
                                                                            <button
                                                                                className="action_btn opt-nowrap w-100 disabl"
                                                                                onClick={() => {
                                                                                    handleOpen();
                                                                                }}
                                                                            >
                                                                                Continue verification
                                                                            </button>
                                                                        ) : getKYCData == 1 ? (
                                                                            <Link to="/deposit">
                                                                                <button
                                                                                    className="action_btn opt-nowrap w-100 kyc_depo_nw"
                                                                                    type="button"
                                                                                >
                                                                                    Deposit
                                                                                </button>
                                                                            </Link>
                                                                        ) : (
                                                                            <button
                                                                                className="action_btn opt-nowrap w-100"
                                                                                onClick={() => {
                                                                                    handleOpen();
                                                                                }}
                                                                            >
                                                                                Verify Now
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>

                                                {/* FAQ */}
                                                <div className="col-lg-5">
                                                    <div>
                                                        <div className="container-lg">
                                                            <div
                                                                className="accordion accordion-flush"
                                                                id="accordionFlushExample"
                                                            >
                                                                <div className="faq mt-5">
                                                                    <h5 className="faq-title">FAQ</h5>
                                                                    <div className="accordion-item font-satoshi">
                                                                        <h2
                                                                            className="accordion-header"
                                                                            id="flush-headingOne"
                                                                        >
                                                                            <button
                                                                                className="accordion-button collapsed"
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target="#flush-collapseOne"
                                                                                aria-expanded="false"
                                                                                aria-controls="flush-collapseOne"
                                                                            >
                                                                                1. Why is KYC verification required?
                                                                            </button>
                                                                        </h2>
                                                                        <div
                                                                            id="flush-collapseOne"
                                                                            className="accordion-collapse collapse"
                                                                            aria-labelledby="flush-headingOne"
                                                                            data-bs-parent="#accordionFlushExample"
                                                                        >
                                                                            <div className="accordion-body">
                                                                                KYC verification is essential to comply
                                                                                with regulations and ensure the security
                                                                                of our platform by preventing fraud and
                                                                                other illegal activities.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="accordion-item font-satoshi">
                                                                        <h2
                                                                            className="accordion-header"
                                                                            id="flush-headingTwo"
                                                                        >
                                                                            <button
                                                                                className="accordion-button collapsed max-wrap"
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target="#flush-collapseTwo"
                                                                                aria-expanded="false"
                                                                                aria-controls="flush-collapseTwo"
                                                                            >
                                                                                2. What documents are needed for KYC
                                                                                verification?
                                                                            </button>
                                                                        </h2>
                                                                        <div
                                                                            id="flush-collapseTwo"
                                                                            className="accordion-collapse collapse"
                                                                            aria-labelledby="flush-headingTwo"
                                                                            data-bs-parent="#accordionFlushExample"
                                                                        >
                                                                            <div className="accordion-body">
                                                                                You will need to submit a
                                                                                government-issued ID (like a passport or
                                                                                driver's license) and a recent proof of
                                                                                address (such as a utility bill or bank
                                                                                statement).
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="accordion-item font-satoshi">
                                                                        <h2
                                                                            className="accordion-header"
                                                                            id="flush-headingThree"
                                                                        >
                                                                            <button
                                                                                className="accordion-button collapsed"
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target="#flush-collapseThree"
                                                                                aria-expanded="false"
                                                                                aria-controls="flush-collapseThree"
                                                                            >
                                                                                3. How long does the KYC process take?
                                                                            </button>
                                                                        </h2>
                                                                        <div
                                                                            id="flush-collapseThree"
                                                                            className="accordion-collapse collapse"
                                                                            aria-labelledby="flush-headingThree"
                                                                            data-bs-parent="#accordionFlushExample"
                                                                        >
                                                                            <div className="accordion-body">
                                                                                The verification process will be
                                                                                completed once the submitted documents
                                                                                have been reviewed and approved by the
                                                                                admin team.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="accordion-item font-satoshi">
                                                                        <h2
                                                                            className="accordion-header"
                                                                            id="flush-headingFour"
                                                                        >
                                                                            <button
                                                                                className="accordion-button collapsed"
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target="#flush-collapseFour"
                                                                                aria-expanded="false"
                                                                                aria-controls="flush-collapseFour"
                                                                            >
                                                                                4. Is my personal information safe?
                                                                            </button>
                                                                        </h2>
                                                                        <div
                                                                            id="flush-collapseFour"
                                                                            className="accordion-collapse collapse"
                                                                            aria-labelledby="flush-headingFour"
                                                                            data-bs-parent="#accordionFlushExample"
                                                                        >
                                                                            <div className="accordion-body">
                                                                                Yes, we use encryption and follow strict
                                                                                data protection regulations to ensure
                                                                                that your personal information remains
                                                                                secure.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="accordion-item font-satoshi">
                                                                        <h2
                                                                            className="accordion-header"
                                                                            id="flush-headingFive"
                                                                        >
                                                                            <button
                                                                                className="accordion-button collapsed max-wrap"
                                                                                type="button"
                                                                                data-bs-toggle="collapse"
                                                                                data-bs-target="#flush-collapseFive"
                                                                                aria-expanded="false"
                                                                                aria-controls="flush-collapseFive"
                                                                            >
                                                                                5. What should I do if my KYC
                                                                                verification is rejected?
                                                                            </button>
                                                                        </h2>
                                                                        <div
                                                                            id="flush-collapseFive"
                                                                            className="accordion-collapse collapse"
                                                                            aria-labelledby="flush-headingFive"
                                                                            data-bs-parent="#accordionFlushExample"
                                                                        >
                                                                            <div className="accordion-body">
                                                                                If your verification is rejected, you
                                                                                will receive an email with the reasons
                                                                                and instructions on how to resolve the
                                                                                issue.
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="row">
                                            <div className="identification_title">Identification</div>
                                            <div className="col-lg-7">
                                                <div className="deposit mt-5 h-100">
                                                    <div className="dep-kyc">
                                                        <div className="dep-kyc-head">
                                                            <img
                                                                src={WARNICON}
                                                                alt="warn-icon"
                                                                className="deposit-imp-icon"
                                                            />
                                                            <h6>Identification Temporarily Unavailable</h6>
                                                        </div>

                                                        <p>{siteData.kycMaintenance}</p>
                                                        <p className="my-3"></p>
                                                        <div>
                                                            <img
                                                                src={require("../assets/kyc-unavail.png")}
                                                                alt="Verify kyc"
                                                                className="before_kyc_depo withdraw-p-l-24"
                                                            />
                                                        </div>
                                                        <p className="mt-4">
                                                            Thank you for your patience and understanding.
                                                        </p>
                                                        <div className="withdraw-p-l-24">
                                                            <Link to="/dashboard">
                                                                <button className="action_btn w-100 mb-2">
                                                                    Back To Home
                                                                </button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* FAQ */}
                                            <div className="col-lg-5">
                                                <div>
                                                    <div className="container">
                                                        <div
                                                            className="accordion accordion-flush"
                                                            id="accordionFlushExample"
                                                        >
                                                            <div className="faq mt-5">
                                                                <h5 className="faq-title">FAQ</h5>
                                                                <div className="accordion-item font-satoshi">
                                                                    <h2
                                                                        className="accordion-header"
                                                                        id="flush-headingOne"
                                                                    >
                                                                        <button
                                                                            className="accordion-button collapsed"
                                                                            type="button"
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target="#flush-collapseOne"
                                                                            aria-expanded="false"
                                                                            aria-controls="flush-collapseOne"
                                                                        >
                                                                            1. Why is KYC verification required?
                                                                        </button>
                                                                    </h2>
                                                                    <div
                                                                        id="flush-collapseOne"
                                                                        className="accordion-collapse collapse"
                                                                        aria-labelledby="flush-headingOne"
                                                                        data-bs-parent="#accordionFlushExample"
                                                                    >
                                                                        <div className="accordion-body">
                                                                            KYC verification is essential to comply
                                                                            with regulations and ensure the security
                                                                            of our platform by preventing fraud and
                                                                            other illegal activities.
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="accordion-item font-satoshi">
                                                                    <h2
                                                                        className="accordion-header"
                                                                        id="flush-headingTwo"
                                                                    >
                                                                        <button
                                                                            className="accordion-button collapsed max-wrap"
                                                                            type="button"
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target="#flush-collapseTwo"
                                                                            aria-expanded="false"
                                                                            aria-controls="flush-collapseTwo"
                                                                        >
                                                                            2. What documents are needed for KYC
                                                                            verification?
                                                                        </button>
                                                                    </h2>
                                                                    <div
                                                                        id="flush-collapseTwo"
                                                                        className="accordion-collapse collapse"
                                                                        aria-labelledby="flush-headingTwo"
                                                                        data-bs-parent="#accordionFlushExample"
                                                                    >
                                                                        <div className="accordion-body">
                                                                            You will need to submit a
                                                                            government-issued ID (like a passport or
                                                                            driver's license) and a recent proof of
                                                                            address (such as a utility bill or bank
                                                                            statement).
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="accordion-item font-satoshi">
                                                                    <h2
                                                                        className="accordion-header"
                                                                        id="flush-headingThree"
                                                                    >
                                                                        <button
                                                                            className="accordion-button collapsed"
                                                                            type="button"
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target="#flush-collapseThree"
                                                                            aria-expanded="false"
                                                                            aria-controls="flush-collapseThree"
                                                                        >
                                                                            3. How long does the KYC process take?
                                                                        </button>
                                                                    </h2>
                                                                    <div
                                                                        id="flush-collapseThree"
                                                                        className="accordion-collapse collapse"
                                                                        aria-labelledby="flush-headingThree"
                                                                        data-bs-parent="#accordionFlushExample"
                                                                    >
                                                                        <div className="accordion-body">
                                                                            The verification process will be completed
                                                                            once the submitted documents have been
                                                                            reviewed and approved by the admin team.
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="accordion-item font-satoshi">
                                                                    <h2
                                                                        className="accordion-header"
                                                                        id="flush-headingFour"
                                                                    >
                                                                        <button
                                                                            className="accordion-button collapsed"
                                                                            type="button"
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target="#flush-collapseFour"
                                                                            aria-expanded="false"
                                                                            aria-controls="flush-collapseFour"
                                                                        >
                                                                            4. Is my personal information safe?
                                                                        </button>
                                                                    </h2>
                                                                    <div
                                                                        id="flush-collapseFour"
                                                                        className="accordion-collapse collapse"
                                                                        aria-labelledby="flush-headingFour"
                                                                        data-bs-parent="#accordionFlushExample"
                                                                    >
                                                                        <div className="accordion-body">
                                                                            Yes, we use encryption and follow strict
                                                                            data protection regulations to ensure that
                                                                            your personal information remains secure.
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="accordion-item font-satoshi">
                                                                    <h2
                                                                        className="accordion-header"
                                                                        id="flush-headingFive"
                                                                    >
                                                                        <button
                                                                            className="accordion-button collapsed max-wrap"
                                                                            type="button"
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target="#flush-collapseFive"
                                                                            aria-expanded="false"
                                                                            aria-controls="flush-collapseFive"
                                                                        >
                                                                            5. What should I do if my KYC verification
                                                                            is rejected?
                                                                        </button>
                                                                    </h2>
                                                                    <div
                                                                        id="flush-collapseFive"
                                                                        className="accordion-collapse collapse"
                                                                        aria-labelledby="flush-headingFive"
                                                                        data-bs-parent="#accordionFlushExample"
                                                                    >
                                                                        <div className="accordion-body">
                                                                            If your verification is rejected, you will
                                                                            receive an email with the reasons and
                                                                            instructions on how to resolve the issue.
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </section>

                                {/* New verification popup - surya */}
                                <Modal
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="email-popup-modal-title"
                                    aria-describedby="email-popup-modal-description"
                                >
                                    <Box sx={style}>
                                        {CurrentStep == "aadhar" ? (
                                            <div className="">
                                                <div className="modal-content">
                                                    <div className="modal-header lvl-one-header">
                                                        <h1
                                                            className="modal-title fs-5"
                                                            id="exampleModalLabel"
                                                        >
                                                            <span className="mar-lft-2">
                                                                Aadhar Verification{" "}
                                                            </span>
                                                        </h1>
                                                        <button
                                                            type="button"
                                                            className="btn-close btn-close-custom"
                                                            onClick={handleClose}
                                                        ></button>
                                                    </div>

                                                    <div className="modal-not-header">
                                                        <div className="modal-notify-content">
                                                            To complete Aadhar verification, Please provide
                                                            your basic information. Thank you!
                                                        </div>
                                                    </div>

                                                    <div className="modal-body personal_verify_body lvl-one-body">
                                                        <div className="mar-top-9">
                                                            <div className="first_name">
                                                                {/* <img
                                                                src={require("../assets/Aadhar.png")}
                                                                width="100%"
                                                                alt=""
                                                            /> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="modal-footer lvl-one-body">
                                                        <button
                                                            className="modal_continue_btn"

                                                            onClick={() => GetAadharLink()}
                                                        >
                                                            Start Verification
                                                        </button>
                                                        <p className="modal_footer_text mar-top-15">
                                                            This information is used for identity verification
                                                            only, and
                                                            <br /> will be kept secure by Hastyex
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : CurrentStep === "pan" ? (
                                            <div className="modal-dialog modal-dialog-centered modal-md">
                                                <div className="modal-content">
                                                    <div className="modal-header lvl-one-header">
                                                        <h1
                                                            className="modal-title fs-5"
                                                            id="exampleModalLabel"
                                                        >
                                                            <span className="mar-lft-2">
                                                                PAN Verification{" "}
                                                            </span>
                                                        </h1>
                                                        <button
                                                            type="button"
                                                            className="btn-close btn-close-custom"
                                                            onClick={handleClose}
                                                        ></button>
                                                    </div>

                                                    <div className="modal-not-header">
                                                        <div className="modal-notify-content">
                                                            To complete PAN verification, Please provide your
                                                            basic information. Thank you!
                                                        </div>
                                                    </div>

                                                    <div className="modal-body personal_verify_body lvl-one-body">
                                                        <div className="id_number">
                                                            <div className="first_name">
                                                                <h4 className="select_id_text">PAN Number</h4>
                                                                <input
                                                                    type="text"
                                                                    value={panNumber}
                                                                    onChange={handlePanChange}
                                                                    placeholder="Enter your PAN number"
                                                                    className="w-100"
                                                                    maxLength={10}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="modal-footer lvl-one-body">
                                                        <button
                                                            className="modal_continue_btn"
                                                            onClick={() => verifyPAN()}
                                                        >
                                                            Submit
                                                        </button>
                                                        <p className="modal_footer_text mar-top-15">
                                                            This information is used for identity verification
                                                            only, and
                                                            <br /> will be kept secure by Hastyex
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ) :
                                            (
                                                // New Bank verification UI
                                                <div className="modal-dialog modal-dialog-centered modal-md">
                                                    <div className="modal-content">
                                                        <div className="modal-header lvl-one-header">
                                                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                                                <span className="mar-lft-2">Bank Account Verification</span>
                                                            </h1>
                                                            <button
                                                                type="button"
                                                                className="btn-close btn-close-custom"
                                                                onClick={handleClose}
                                                            ></button>
                                                        </div>
                                                        <div className="modal-not-header">
                                                            <div className="modal-notify-content">
                                                                To complete bank verification, please provide your account details.
                                                            </div>
                                                        </div>
                                                        <div className="modal-body personal_verify_body lvl-one-body">
                                                            <div className="id_number">
                                                                <div className="first_name">
                                                                    <h4 className="select_id_text">Account Number</h4>
                                                                    <input
                                                                        type="text"
                                                                        value={accountNumber}
                                                                        onChange={(e) => setAccountNumber(e.target.value.replace(/\D/g, ''))}
                                                                        placeholder="Enter your account number"
                                                                        className="w-100"
                                                                        maxLength={20}
                                                                    />
                                                                </div>
                                                                <div className="first_name mt-3">
                                                                    <h4 className="select_id_text">IFSC Code</h4>
                                                                    <input
                                                                        type="text"
                                                                        value={ifscCode}
                                                                        onChange={(e) => setIfscCode(e.target.value.toUpperCase())}
                                                                        placeholder="Enter your IFSC code"
                                                                        className="w-100"
                                                                        maxLength={11}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="modal-footer lvl-one-body">
                                                            <button
                                                                className="modal_continue_btn"
                                                                onClick={verifyBankAccount}
                                                            >
                                                                Verify Bank Account
                                                            </button>
                                                            <p className="modal_footer_text mar-top-15">
                                                                This information is used for identity verification only, and
                                                                <br /> will be kept secure by Hastyex
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            )

                                        }
                                    </Box>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </main>
            )}
        </>
    );
};

export default Dashboard;
